import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import ReactSelect from "../../UI/ReactSelect";
import axios from "axios";
import SelectAsyncPaginate from "../../UI/ReactAsyncSelect";
// import { dateConvertMonth } from "../../../../helpers/dateConvertItem";


export default function Filter(props) {
  const {
    onHide,
    show,
    filterInputsUpdate,
    filterInputsUpdateSelect,
    filterInputs,
    assets,

  } = props;
  const [assetsOption, setAssetsOption] = React.useState(null);
  function handleChangeAssets(value) {
    setAssetsOption(value);
    filterInputsUpdateSelect("assetId", value.value);
  }
  const [partnersOption, setPartnersOption] = React.useState(null);
  function handleChangePartners(value) {
    setPartnersOption(value);
    filterInputsUpdateSelect("partnerId", value?.value);
  }
  const [employeesOption, setEmployeesOption] = React.useState(null);
  function handleChangeEmployees(value) {
    setEmployeesOption(value);
    filterInputsUpdateSelect("employeeId", value?.value);
  }

  const assetsOptions = assets.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));
  // const partnersOptions = partners.map((suggestion) => ({
  //   value: suggestion.id,
  //   label: suggestion.name,
  // }));
  // const employeesOptions = employees.map((suggestion) => ({
  //   value: suggestion.id,
  //   label: suggestion.userName,
  // }));


  const loadOptions = async (search, loadedOptions, { page }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}employee/forAdmin?&Skip=${page * 30}&Take=30`
    );

    let responseJSON = await response.data.data;
    responseJSON = responseJSON.map((item) => ({
      value: item.id,
      label: item.userName
    }));

    return {
      options: responseJSON,
      hasMore: responseJSON.length ? true : false,
      additional: {
        page: page + 1
      }
    };

  };


  const loadOptionsPartner = async (search, loadedOptions, { page }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}partner/filter?name=${search}&Skip=${page * 30}&Take=30`
    );

    let responseJSON = await response.data.data;
    responseJSON = responseJSON.map((item) => ({
      value: item.id,
      label: item.name
    }));

    return {
      options: responseJSON,
      hasMore: responseJSON.length ? true : false,
      additional: {
        page: page + 1
      }
    };

  };



  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create"> Usage histories filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  id="assetId"
                  name="assetId"
                  suggestions={assetsOptions}
                  handleChangeSingle={handleChangeAssets}
                  single={assetsOption}
                  label="Choose asset"
                  placeholder="Choose asset"
                  inputId="assetId"
                  value={filterInputs.assetId}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="campaignName"
                  name="campaignName"
                  label="Campaign Name"
                  placeholder="Campaign Name"
                  className="w-100"
                  value={filterInputs.campaignName}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                {/* <ReactSelect
                  id="partnerId"
                  name="partnerId"
                  suggestions={partnersOptions}
                  handleChangeSingle={handleChangePartners}
                  single={partnersOption}
                  label="Choose partner"
                  placeholder="Choose partner"
                  inputId="partnerId"
                  value={filterInputs.partnerId}
                /> */}
                <SelectAsyncPaginate
                  loadOptions={loadOptionsPartner}
                  onChange={handleChangePartners}
                  value={partnersOption}
                  label="Choose partner"
                  placeholder="Choose partner"
                  inputId="partnerId"
                />
              </div>
            </div>




            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                {/* <ReactSelect
                  id="employeeId"
                  name="employeeId"
                  suggestions={employeesOptions}
                  handleChangeSingle={handleChangeEmployees}
                  single={employeesOption}
                  label="Choose employees"
                  placeholder="Choose employees"
                  inputId="employeeId"
                  value={filterInputs.employeeId}
                /> */}

                <SelectAsyncPaginate
                  loadOptions={loadOptions}
                  onChange={handleChangeEmployees}
                  value={employeesOption}
                  label="Choose employees"
                  placeholder="Choose employees"
                  inputId="employeeId"
                />
              </div>
            </div>


            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <InputLabel htmlFor="createdDate" className="date-label">Start date</InputLabel>
                <TextField
                  id="startDate"
                  name="startDate"
                  type="date"
                  className="w-100"
                  value={(filterInputs.startDate)}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <InputLabel htmlFor="endDate" className="date-label">End date</InputLabel>
                <TextField
                  id="endDate"
                  name="endDate"
                  type="date"
                  className="w-100"
                  value={(filterInputs.endDate)}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>


          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
